import { MODULE_NAME } from './const';
import StoreModuleService from '../StoreModuleService';

const defaultTemplateText = `Hi {{name}} {{surname}},
	Your invoice is ready. Please pay it by {{dueDate}}.
	Thank you,
	{{companyName}}
	


	This email was sent using Ply
	`;
const defaultEmailTemplateData = { id: 1, text: defaultTemplateText };

const buildGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// When we remove this, create a fetchEmailTemplatesAction,
// that fetches email templates from server and sets them in the store using SET_EMAIL_TEMPLATES mutation

// getters declarations
export const defaultEmailTemplate = buildGetterObject('defaultEmailTemplate');
export const selectedEmailTemplate = buildGetterObject('selectedEmailTemplate');
export const selectedEmailTemplateId = buildGetterObject('selectedEmailTemplateId');
export const useEmailTemplate = buildGetterObject('useEmailTemplate');
export const useEmailTemplates = buildGetterObject('useEmailTemplates');
export const useEmailTemplatesArr = buildGetterObject('useEmailTemplates');

const getters = {
	[defaultEmailTemplate.getter]: () => defaultEmailTemplateData,
	[selectedEmailTemplateId.getter]: (state) => state.selectedEmailTemplateId,

	// Remove the getter from defaulting to defaultEmailTemplate and make the users of this getter default to it if they want
	[selectedEmailTemplate.getter]: (state, getters) => state.selectedEmailTemplate || getters[defaultEmailTemplate.getter],

	[useEmailTemplates.getter]: (state) => state.templates,
	[useEmailTemplatesArr.getter]: (state) => Object.values(state.templates),
	[useEmailTemplate.getter]: (state) => (templateId) => state.templates[templateId],
};

export default getters;
